import { render, staticRenderFns } from "./DeleteBannerModal.vue?vue&type=template&id=901ddf46"
import script from "./DeleteBannerModal.vue?vue&type=script&lang=ts"
export * from "./DeleteBannerModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports